import React, { Component } from "react";
import PropTypes from "prop-types";
import Apple2 from "../Icons/Apple2.icon";
import Cog from "../Icons/Cog.icon";
import Gauge from "../Icons/Gauge.icon";
import Data from "../Icons/Data.icon";
import Brain from "../Icons/Brain.icon";
import Computer from "../Icons/Computer.icon";
import Mobile from "../Icons/Mobile.icon";
import Database from "../Icons/Database.icon";

export default class learningResourcesTemp extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isActive: false,
    };

    this.toggleActive = this.toggleActive.bind(this);
  }

  toggleActive() {
    this.setState({
      isActive: !this.state.isActive,
    });
  }

  render() {
    return (
      <div className="bg-white rounded w-100 pb-5 mb-5">
        <div className="row d-flex justify-content-center border-grey-line d-flex align-items-stretch pt-4 px-3 px-lg-0 position-relative">
          <div className="col-12 col-sm-5 col-xl-2 mb-3 mt-2 px-lg-0 mx-lg-2">
            <div className="bg-white w-100 h-100 d-flex flex-column align-items-start border-grey-panel-dark rounded pt-3">
              <div className="align-self-center text-center circle-white">
                <div className="d-flex align-items-center justify-content-center circle-white">
                  <i className="fill-primary">
                    <Computer
                      className="fill-primary pb-2"
                      height="80%"
                      width="80%"
                    />
                  </i>
                </div>
              </div>
              <div className="text-center px-3 pb-3 w-100">
                <h6 className="pb-2">
                  <strong>
                    School <br />
                    Portal
                  </strong>
                </h6>
                <p
                  className={`pb-2 px-2 text-center ${
                    this.state.isActive ? "d-none" : "d-inline"
                  }`}
                >
                  Track, visualise and analyse your school's own energy data
                  over days, months, seasons and years.
                </p>
              </div>
            </div>
          </div>

          <div className="col-12 col-sm-5 col-xl-2 mb-3 mt-2 px-lg-0 mx-lg-2">
            <div className="bg-white w-100 h-100 d-flex flex-column align-items-start border-grey-panel-dark rounded pt-3">
              <div className="align-self-center text-center">
                <div className="d-flex align-items-center justify-content-center circle-white">
                  <i className="fill-primary">
                    <Apple2
                      className="fill-primary pb-2"
                      height="80%"
                      width="80%"
                    />
                  </i>
                </div>
              </div>
              <div className="text-center px-3 pb-3 w-100">
                <h6 className="pb-2">
                  <strong>
                    Teacher's
                    <br /> Toolkit
                  </strong>
                </h6>
                <p
                  className={`pb-2 px-2 text-center ${
                    this.state.isActive ? "d-none" : "d-inline"
                  }`}
                >
                  Find detailed unit plans, lesson plans and student activities
                  for all year levels, ready to use straight 'off-the-shelf'.
                </p>
              </div>
            </div>
          </div>

          <div className="col-12 col-sm-5 col-xl-2 mb-3 mt-2 px-lg-0 mx-lg-2">
            <div className="bg-white w-100 h-100 d-flex flex-column align-items-start border-grey-panel-dark rounded pt-3">
              <div className="align-self-center text-center">
                <div className="d-flex align-items-center justify-content-center circle-white">
                  <i className="fill-primary">
                    <Brain
                      className="fill-primary pb-2"
                      height="80%"
                      width="80%"
                    />
                  </i>
                </div>
              </div>
              <div className="text-center px-3 pb-3 w-100">
                <h6 className="pb-2">
                  <strong>
                    Knowledge
                    <br /> Bank
                  </strong>
                </h6>
                <p
                  className={`pb-2 px-2 text-center ${
                    this.state.isActive ? "d-none" : "d-inline"
                  }`}
                >
                  Give students access to references, research and resources for
                  self-directed learning, all in one place.
                </p>
              </div>
            </div>
          </div>

          <div className="col-12 col-sm-5 col-xl-2 mb-3 mt-2 px-lg-0 mx-lg-2">
            <div className="bg-white w-100 h-100 d-flex flex-column align-items-start border-grey-panel-dark rounded pt-3">
              <div className="align-self-center text-center">
                <div className="d-flex align-items-center justify-content-center circle-white">
                  <i className="fill-primary">
                    <Mobile
                      className="fill-primary pb-2"
                      height="80%"
                      width="80%"
                    />
                  </i>
                </div>
              </div>
              <div className="text-center px-3 pb-3 w-100">
                <h6 className="pb-2">
                  <strong>
                    <span>Planet</span>
                    <br /> Watch
                  </strong>
                </h6>
                <p
                  className={`pb-2 px-2 text-center ${
                    this.state.isActive ? "d-none" : "d-inline"
                  }`}
                >
                  Gamify learning with this fun iPad app that helps students
                  understand the impacts of energy consumption.
                </p>
              </div>
            </div>
          </div>

          <div className="col-12 col-sm-5 col-xl-2 mb-3 mt-2 px-lg-0 mx-lg-2">
            <div className="bg-white w-100 h-100 d-flex flex-column align-items-start border-grey-panel-dark rounded pt-3">
              <div className="align-self-center text-center">
                <div className="d-flex align-items-center justify-content-center circle-white">
                  <i className="fill-primary">
                    <Database
                      className="fill-primary pb-2"
                      height="80%"
                      width="80%"
                    />
                  </i>
                </div>
              </div>
              <div className="text-center px-3 pb-3 w-100">
                <h6 className="pb-2">
                  <strong>
                    Public <br />
                    <span>API</span>
                  </strong>
                </h6>
                <p
                  className={`pb-2 px-2 text-center ${
                    this.state.isActive ? "d-none" : "d-inline"
                  }`}
                >
                  Interact directly with your school's raw energy data to
                  develop your own in-house applications and visualisations.
                </p>
              </div>
            </div>
          </div>

          <div className="col-12 col-sm-5 col-xl-2 mb-3 mt-2 px-lg-0 mx-lg-2">
            <div className="bg-white w-100 h-100 d-flex flex-column align-items-start border-grey-panel-dark rounded pt-3">
              <div className="align-self-center text-center">
                <div className="d-flex align-items-center justify-content-center circle-white">
                  <i className="fill-primary">
                    <Cog
                      className="fill-primary pb-2"
                      height="80%"
                      width="80%"
                    />
                  </i>
                </div>
              </div>
              <div className="text-center px-3 pb-3 w-100">
                <h6 className="pb-2">
                  <strong>
                    Engine Room <br />
                    <span>Online Tools</span>
                  </strong>
                </h6>
                <p
                  className={`pb-2 px-2 text-center ${
                    this.state.isActive ? "d-none" : "d-inline"
                  }`}
                >
                  Explore and understand your school's energy use through energy
                  management and site configuration tools.
                </p>
              </div>
            </div>
          </div>

          <div className="col-12 col-sm-5 col-xl-2 mb-3 mt-2 px-lg-0 mx-lg-2">
            <div className="bg-white w-100 h-100 d-flex flex-column align-items-start border-grey-panel-dark rounded pt-3">
              <div className="align-self-center text-center">
                <div className="d-flex align-items-center justify-content-center circle-white">
                  <i className="fill-primary">
                    <Gauge
                      className="fill-primary pb-2"
                      height="80%"
                      width="80%"
                    />
                  </i>
                </div>
              </div>
              <div className="text-center px-3 pb-3 w-100">
                <h6 className="pb-2">
                  <strong>
                    Power Widgets for <br />
                    <span>School Website</span>
                  </strong>
                </h6>
                <p
                  className={`pb-2 px-2 text-center ${
                    this.state.isActive ? "d-none" : "d-inline"
                  }`}
                >
                  Proudly showcase your school's energy data on your website by
                  installing our attractive widget.
                </p>
              </div>
            </div>
          </div>

          <div className="col-12 col-sm-5 col-xl-2 mb-3 mt-2 px-lg-0 mx-lg-2">
            <div className="bg-white w-100 h-100 d-flex flex-column align-items-start border-grey-panel-dark rounded pt-3">
              <div className="align-self-center text-center">
                <div className="d-flex align-items-center justify-content-center circle-white">
                  <i className="fill-primary">
                    <Data
                      className="fill-primary pb-2"
                      height="80%"
                      width="80%"
                    />
                  </i>
                </div>
              </div>
              <div className="text-center px-3 pb-3 w-100">
                <h6 className="pb-2">
                  <strong>
                    LED In-School <br />
                    <span>Energy Display</span>
                  </strong>
                </h6>
                <p
                  className={`pb-2 px-2 text-center ${
                    this.state.isActive ? "d-none" : "d-inline"
                  }`}
                >
                  Keep energy top-of-mind by displaying your data on an LED
                  display in your school.
                </p>
              </div>
            </div>
          </div>

          <div
            onClick={this.toggleActive}
            className="row w-100 mx-0 justify-content-center"
          >
            <div className="semi-circle-bottom text-grey-line border-grey-line border-top-white border-width-medium text-center fa-2x position-absolute d-flex justify-content-center align-items-center">
              <i
                className={`pb-2 px-2 text-center ${
                  this.state.isActive
                    ? "fa fa-angle-double-up"
                    : "fa fa-angle-double-down"
                }`}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/app/LearningResourcesTemp/index.js